import type { IconSvgObject } from './types';

/** @deprecated Renamed to `CircleSlash2Icon`; this file will be removed in the next major version. */
const CircleSlashTwoIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleSlashTwoIcon;
